import { BusinessUnit } from '../dto/patient-details';
import {
    IRecordImageSequence,
    IRecordSeriesSequence,
    IRecordStudySequence,
    IVnaDicomRequest,
} from './vna-dicom-request.interfaces';

export class VnaDicomRequest implements IVnaDicomRequest {
    recordStudySequence: IRecordStudySequence[];
    command: number;
    sendingApplication: string;
    businessUnit: BusinessUnit;
    requestUID: string;
    patientName: string;
    patientID: string;
    issuer: string;
    patientSex: string;
    patientBirthDate: string;

    constructor(
        command: number,
        sendingApplication: string,
        businessUnit: BusinessUnit,
        requestUID: string,
        patientName: string,
        patientID: string,
        issuer: string,
        patientSex: string,
        patientBirthDate: string,
        recordStudySequence: IRecordStudySequence[],
    ) {
        this.recordStudySequence = recordStudySequence;
        this.command = command;
        this.sendingApplication = sendingApplication;
        this.businessUnit = businessUnit;
        this.requestUID = requestUID;
        this.patientName = patientName;
        this.patientID = patientID;
        this.issuer = issuer;
        this.patientSex = patientSex;
        this.patientBirthDate = patientBirthDate;
    }
}

export class RecordStudySequence implements IRecordStudySequence {
    recordSeriesSequence: IRecordSeriesSequence[];
    studyInstanceUID: string;
    accessNumber: string;
    studyID: string;
    studyDescription: string;
    studyDate: string;
    modality: string;

    constructor(
        recordSeriesSequence: IRecordSeriesSequence[],
        studyInstanceUID: string,
        accessNumber: string,
        studyID: string,
        studyDescription: string,
        studyDate: string,
        modality: string,
    ) {
        this.recordSeriesSequence = recordSeriesSequence;
        this.studyInstanceUID = studyInstanceUID;
        this.accessNumber = accessNumber;
        this.studyID = studyID;
        this.studyDescription = studyDescription;
        this.studyDate = studyDate;
        this.modality = modality;
    }
}

export class RecordSeriesSequence implements IRecordSeriesSequence {
    seriesInstanceUID: string;
    recordImageSequence: IRecordImageSequence[];

    constructor(seriesInstanceUID: string, recordImageSequence: IRecordImageSequence[]) {
        this.seriesInstanceUID = seriesInstanceUID;
        this.recordImageSequence = recordImageSequence;
    }
}

export class RecordImageSequence implements IRecordImageSequence {
    sopClassUID: string;
    sopInstanceUID: string;

    constructor(sopClassUID: string, sopInstanceUID: string) {
        this.sopClassUID = sopClassUID;
        this.sopInstanceUID = sopInstanceUID;
    }
}
